export const state = {
  chatStep: 0,
  doReply: false,
  scrollValue: 0,
  positionTopEarth: 0,
  positionTopAvatar: 0,
  selectedAnswer: '',
  isRightAnswer: true,
  openOverlayType: '',
  showMenuCta: false,
  chatNavigationMenu: false,
  bgStep: 0,
  currentBgStepReload: 0,
  openBadgeType: '',
  finalStep: false,
  badges: {
    chat: false,
    sdg: false,
    cards: false,
    dishes: false,
    pyramid: false
  }
}